// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_5Dh-5","fixed-container":"fixed-container_EJv9G","ant-btn":"ant-btn","ant-spin-nested-loading":"ant-spin-nested-loading"};